import React from 'react';
import Reveal from './Reveal';
import I1 from '../images/logo/nexia.png';
import I2 from '../images/logo/gdsc-logo.svg';

const Experiences = () => {
    const listExperience = [
        {
            img: I1,
            title: "Internship Program",
            subtitle: "Nexia Indonesia",
            desc: "I was responsible for creating documentation of web application and wireframe for the company website. I also learned how to use .net, Flutter, FastAPI, and PostgreSQL.",
        },
        {
            img: I2,
            title: "Top 20 of 650+ Teams",
            subtitle: "GDSC Hackfest 2024",
            desc: "RoadEye was our team traffic analyst website application that created in purpose to solve third SDG. I was responsible for creating backend endpoints and database using FastAPI and PostgreSQL. I also responsible on scraping CCTV link for the display in Frontend.",
        },
    ]
    return (
        <section className="w-full flex justify-center item-center flex-col h-fit min-h-screen" id="Experience">
            <h2 className='py-10 text-white text-7xl font-bold font-poppins text-center'>Experiences & Achievements</h2>
            <div className="w-full">
                {listExperience.map((item) => (
                    <Reveal>
                        <div className="w-full bg-gray-400 rounded-[30px] bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-20 border border-gray-100 px-10 py-8 neumorphism mb-10 flex flex-row items-center">
                            <div className='w-[25%] pr-10 h-full flex justify-center items-center'>
                                <img src={item.img} ></img>
                            </div>
                            <div className='w-[75%] block '>
                                <div className='flex flex-row justify-start items-end flex-wrap pb-5'>
                                    <h1 className="text-gray-400 text-4xl font-poppins font-bold text-center pr-5">{item.title}</h1>
                                    <h1 className="text-white text-3xl font-poppins font-bold text-center">{item.subtitle}</h1>
                                </div>
                                <p className="text-white text-lg pb-5 font-poppins text-justify">{item.desc}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
};

export default Experiences;
